module.exports = __webpack_public_path__ + "static/media/cash.f183ad3b.png";